import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CONTACT, STAFF_CONTACTS } from "@/data/site";

export function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-obsidian" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-6 max-w-sm font-body text-sm leading-relaxed text-white/50">
              Elite soccer training for the next generation. Building complete players across{" "}
              {CONTACT.serviceArea}.
            </p>
          </div>

          <div>
            <h4 className="font-body text-xs font-bold uppercase tracking-[0.25em] text-neon-green">Explore</h4>
            <ul className="mt-5 space-y-3">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Training", "/training"],
                ["Camps", "/camps"],
                ["FAQ", "/faq"],
                ["Sign Up", "/register"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="font-body text-sm text-white/60 transition-colors hover:text-neon-green">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-body text-xs font-bold uppercase tracking-[0.25em] text-neon-green">Contact</h4>
            <ul className="mt-5 space-y-4 font-body text-sm text-white/60">
              {STAFF_CONTACTS.map((s) => (
                <li key={s.email}>
                  <div className="font-body text-xs font-bold uppercase tracking-widest text-white/80">{s.name}</div>
                  <a href={`mailto:${s.email}`} className="mt-1 flex items-center gap-3 hover:text-neon-green"><Mail size={16} strokeWidth={2.5} className="text-neon-green" /> {s.email}</a>
                  <a href={`tel:${s.phone.replace(/[^0-9]/g, "")}`} className="mt-1 flex items-center gap-3 hover:text-neon-green"><Phone size={16} strokeWidth={2.5} className="text-neon-green" /> {s.phone}</a>
                </li>
              ))}
              <li className="flex items-center gap-3"><MapPin size={16} strokeWidth={2.5} className="text-neon-green" /> {CONTACT.location}</li>
            </ul>
            <div className="mt-5 flex gap-4">
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white/60 hover:text-neon-green"><Instagram size={20} strokeWidth={2.5} /></a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <p className="font-body text-xs text-white/40">© {new Date().getFullYear()} ARD Midsouth Performance. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-body text-xs uppercase tracking-widest text-white/30 hover:text-neon-green">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
